import { useState, useEffect, useCallback } from 'react';
import { keysToCamelFromSnake } from '../../../utils/caseconverters';

export function useArticlePagination(items, hasMore, nextPage, mmId) {
    const [pages, setPages] = useState(items ?? []);
    const [hasMoreState, setHasMore] = useState(hasMore ?? false);
    const [nextPageState, setNextPage] = useState(nextPage ?? null);
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        setPages(items ?? []);
        setHasMore(hasMore ?? false);
        setNextPage(nextPage ?? null);
    }, [items, hasMore, nextPage]);

    const onLoadMore = useCallback(async () => {
        if (!hasMoreState || !nextPageState || isLoading || !mmId) return;
        setIsLoading(true);
        try {
            const currentParams = new URLSearchParams(window.location.search);
            const fetchParams = new URLSearchParams({
                mm: mmId,
                page: nextPageState,
            });
            for (const key of ['q', 'topics']) {
                if (currentParams.has(key))
                    fetchParams.set(key, currentParams.get(key));
            }
            const response = await fetch(
                `/wt/fenix/media-monitor/?${fetchParams.toString()}`
            );
            if (!response.ok) throw new Error(`HTTP ${response.status}`);
            const data = keysToCamelFromSnake(await response.json());
            setPages((prev) => [...prev, ...(data.items ?? [])]);
            setHasMore(data.hasMore ?? false);
            setNextPage(data.nextPage ?? null);
        } catch (error) {
            console.error('Error loading more articles:', error);
        } finally {
            setIsLoading(false);
        }
    }, [hasMoreState, nextPageState, isLoading, mmId]);

    return { pages, hasMore: hasMoreState, isLoading, onLoadMore };
}
